

























































// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import EditBaseFlux from '@/components/flux/edit/EditBaseFlux.vue'
import { AloFlux, getDefaultAloFlux } from '@/models/alo/AloFlux'
import * as rules from '@/utils/validationRules'
import { TypeOffre } from '@/enum/TypeOffre'
import { toSubArray } from '@/utils/groupBy'

@Component({
  name: 'EditConfig',    
  components:{EditBaseFlux},  
  props: {   
    dispoEditable:{
      type:Boolean,
      default:true      
    },
    segmentEditable:{
      type:Boolean,
      default:true      
    },
    stockEditable:{
      type:Boolean,
      default:true      
    },
    entrepotEditable:{
      type:Boolean,
      default:true      
    },    
    transporteurEditable:{
      type:Boolean,
      default:true      
    },    
  }
})
export default class EditConfig extends Vue {
  
  private flux = getDefaultAloFlux()
  
  private dispoEditable!:boolean
  private segmentEditable!:boolean
  private stockEditable!:boolean
  private entrepotEditable!:boolean
  private transporteurEditable!:boolean
  
  ruleRequired(v:string) {
    return rules.ruleRequired(v)
  }

  edit(item:AloFlux) {    
    this.flux = (this.$refs.baseEdit as EditBaseFlux).edit(item)
  }  

  get disposList(){
    //@ts-ignore    
    return this.$store.myGetters.disposList
  }

  get dispoExporteGroup(){
    //@ts-ignore    
    return toSubArray(this.disposList,3)
  }

  get transportersList(){
    return this.$store.myGetters.transportersList
  }

  get transportersGroup(){
    //@ts-ignore    
    return toSubArray(this.transportersList,2)
  }

  updateFiltreEntrepot(filtreAdd:number,filtreRemove:number,selected:boolean) {
    if(selected) this.flux.flcFiltreEntrepot = this.flux.flcFiltreEntrepot|filtreAdd
    else this.flux.flcFiltreEntrepot = this.flux.flcFiltreEntrepot&filtreRemove
  }

  updateList(list:Array<number>,id:number,selected:boolean) {
    if(!selected) list.push(id)
    else list.splice(list.findIndex(it => it == id),1)
  }
  
}
